class FaqTab extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const tabTitles = this.querySelectorAll('.tab-title');
    const tabPanels = this.querySelectorAll('.tab-panel');

    if (!tabTitles.length || !tabPanels.length) return;

    // 默认显示第一个 tab-panel
    const firstTab = tabTitles[0];
    const firstTabKey = firstTab.dataset.tab;

    this.activateTab(firstTabKey);

    tabTitles.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabKey = tab.dataset.tab;
        this.activateTab(tabKey);
      });
    });
  }

  activateTab(tabKey) {
    const tabTitles = this.querySelectorAll('.tab-title');
    const tabPanels = this.querySelectorAll('.tab-panel');

    tabTitles.forEach(tab => {
      tab.classList.toggle('active', tab.dataset.tab === tabKey);
    });

    tabPanels.forEach(panel => {
      panel.style.display = panel.dataset.tab === tabKey ? 'block' : 'none';
    });
  }
}
customElements.define('faq-tab', FaqTab);